import AuthMixin from '@/components/mixins/auth-mixin'
import EventBus from '@/components/mixins/event-bus-mixin'
import OnEnterMixin from '@/components/mixins/onenter-mixin'
import FormValidationMixin from '@/components/mixins/form-validation-mixin'

export default {
  name: 'userAccount',
  inject: [
    '$utils',
    '$api',
    '$apiError'
  ],
  props: {
    userInfoProp: {
      default () { return {} }
    },
    isActive: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    userInfoProp (newVal) {
      this.setDefaultData()
    }
  },
  mixins: [AuthMixin, FormValidationMixin, OnEnterMixin],
  data () {
    return {
      editAccountNameForm: {},
      editAccountNameFormRules: {
        accountName: [
          { required: true, message: this.$t('label.requiredAccountName') }
        ]
      },
      userInfo: this.userInfoProp,
      error: '',
      showEditAccountNameError: false,
      editAccountNameError: ''
    }
  },
  methods: {
    emitEvent (action, data) {
      if (action) {
        this.$emit('edit-account-name-dialog-change', { action, payload: { data } })
      }
    },
    setDefaultData () {
      this.userInfo = this.userInfoProp
      const editAccountNameForm = this.$utils.clone(this.editAccountNameForm)
      editAccountNameForm.accountName = this.userInfo?.accountName ?? this.userInfo?.address?.companyName ?? ''

      this.editAccountNameForm = editAccountNameForm
    },
    handleCloseEditAccountNameForm () {
      this.emitEvent('CLOSE_EDIT_ACCOUNT_NAME_DIALOG')
    },
    handleEditAccountNameFormSubmit () {
      const formEl = $(this.$refs.editAccountNameForm.$el)
      formEl.find('.el-form-item').removeClass('animated shake')

      this.$refs.editAccountNameForm.validate((isFormValid) => {
        if (isFormValid) {
          const apiRequest = () => {
            const requestData = {
              accountName: this.editAccountNameForm.accountName
            }

            this.$utils.mainLoader(true)
            this.$api.put(`${CONFIG.API_BASE_URL}/group/info`, requestData)
              .then(response => {
                this.getUserUserInfoFromBackend({
                  callback: () => {
                    this.emitEvent('CLOSE_EDIT_ACCOUNT_NAME_DIALOG', requestData)
                    this.$utils.mainLoader(false)
                    EventBus.$emit('SHOW_CUSTOM_NOTIFICATION', {
                      description: this.$t('label.updatedAccountInfo'),
                      closeButtonText: this.$t('buttons.ok'),
                      callbacks: {
                        eventOnClose: () => {},
                      }
                    })
                  }
                })
              })
              .catch((error) => {
                this.$utils.mainLoader(false)
                this.$apiError.handleAPIRequestError(error, { originalRequest: () => { apiRequest() }, showDialogNotification: true })
              })
          }
          apiRequest()
        } else {
          this.$nextTick(() => {
            // Animate error fields
            formEl.find('.el-form-item').each((indx, el) => {
              if (($(el).hasClass('is-error'))) {
                window.setTimeout(() => { this.$utils.animate(el, 'animated shake') }, 1)
              }
            })
          })

          return false
        }
      })
    },
    onEnter (event) {
      if (event.target.id === 'edit-account-name-input') {
        this.handleEditAccountNameFormSubmit()
      }
    }
  },
  mounted () {
    this.setDefaultData()
  }
}
